import React from 'react';
import { Star, StarHalf } from '@phosphor-icons/react';

export default function Rating({ rating = 0, count, compact = false }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const empty = 5 - full - (half ? 1 : 0);
  return (
    <div className="flex items-center gap-2" data-testid="product-rating">
      <div className="flex items-center text-accent">
        {Array.from({ length: full }).map((_, i) => (
          <Star key={`f${i}`} weight="fill" size={compact ? 14 : 16} />
        ))}
        {half && <StarHalf weight="fill" size={compact ? 14 : 16} />}
        {Array.from({ length: empty }).map((_, i) => (
          <Star key={`e${i}`} weight="regular" size={compact ? 14 : 16} className="text-accent/40" />
        ))}
      </div>
      <span className="text-xs font-medium text-muted-foreground">
        {rating.toFixed(1)}{count != null && <> · {count.toLocaleString('nl-NL')}</>}
      </span>
    </div>
  );
}
